import React from 'react';
import { AnnouncementBar } from './AnnouncementBar';
const navLinks = [{
  label: 'Cosa include',
  href: '#cosa-include'
}, {
  label: 'Bonus',
  href: '#bonus'
}, {
  label: 'Prezzo',
  href: '#prezzo'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function SiteHeader() {
  return <header className="sticky top-0 z-50 w-full" data-id="element-152" data-mp="1io3ayt9xqq60">
      <AnnouncementBar data-id="element-153" data-mp="1iod42pqa1dfx" />
      <div className="border-b border-brand-dark bg-brand-alt/95 backdrop-blur" data-id="element-154" data-mp="1ipwh87gmz8dh">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-4 px-4" data-id="element-155" data-mp="uyis0ads7swq">
          <a href="#top" className="flex items-center gap-2" data-id="element-156" data-mp="qy8d2880hs5q">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/30682d48-c99b-4b6c-bbf3-b8a560147d71.jpg" alt="Ugo il Gufo, mascotte di Biologia Pronta" className="h-9 w-9 rounded-full border border-brand-dark bg-white object-cover" data-id="element-157" data-mp="14wor6k87ekxw" />
            <span className="font-serif text-base font-extrabold leading-none tracking-tight text-brand-deep sm:text-lg" data-id="element-158" data-mp="2bda7xntqr7p5">
              Biologia Pronta
            </span>
          </a>

          <nav aria-label="Sezioni della pagina" className="hidden items-center gap-7 md:flex" data-id="element-159" data-mp="2eidlwvyzc6fb">
            {navLinks.map(({
            label,
            href
          }) => <a key={href} href={href} className="whitespace-nowrap text-sm font-semibold text-brand-gray transition-colors duration-200 ease-out hover:text-brand-green" data-id="element-160" data-mp="2jirjtl6v9zzm">
                {label}
              </a>)}
          </nav>

          <a href="#prezzo" className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-brand-amber px-4 py-2 text-[11px] font-extrabold tracking-wide text-white transition-colors duration-200 ease-out hover:bg-[#CF620F] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber focus-visible:ring-offset-2 sm:px-5 sm:text-xs" data-id="element-161" data-mp="1vsoydnxgjs9z">
            Ottieni Biologia Pronta
          </a>
        </div>
      </div>
    </header>;
}